export const EntityTypes = {
  Task: {
    EntityType: "BoltTask",
  },
} as const;
